// Mock data for the tattoo studio website

export const studioInfo = {
  name: "Tagline Tattoo Studio",
  tagline: "Where Art Meets Skin",
  phone: "076 711 2226",
  email: "info@taglinetattoo.com",
  address: "528 Ratshufi Street, Shop no.3, Markos Pub & Grill, PHOKENG, 0335 Rustenburg, North West",
  hours: "Mon - Sat: 10:30 - 18:30 | Sundays: By appointment only",
  socialMedia: {
    instagram: "https://instagram.com/tagline_tattoo_studio",
    facebook: "https://facebook.com/TaglineTattooStudio",
    tiktok: "https://tiktok.com/@tagline_studio"
  }
};

export const artists = [
{
  id: 1,
  name: "Monde\n",
  specialty: "Tattoo Artist",
  experience: "6 years",
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/vql1mp4o_48b691c4-2b3f-40dd-b24a-1a09f234a0d8.jpg",
  bio: "Known for her versatility and unique style, Monde thrives on pushing creative boundaries. Whether it\u2019s intricate detail, striking blackwork, or something completely custom, she approachs every piece with passion and originality. Monde believes every tattoo should feel personal and powerful, taking time to understand each client\u2019s vision before turning it into art that speaks",
  portfolio: ["tattoo1.jpg", "tattoo2.jpg"]
},
{
  id: 2,
  name: "lucy",
  specialty: "Tattoo Artist\n",
  experience: "3 years",
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/d725ve6b_Screenshot_20250925_100136_com_instagram_android_InstagramMainActivity.jpg",
  bio: "A true creative at core, Lucy brings bold ideas to life through ink. Specializing in clean linework and expressive designs, his work blends technical precision with artistic instinct. Every tattoo is treated as a collaboration. Your story, translated into a piece that lives on your skin forever",
  portfolio: ["tattoo3.jpg", "tattoo4.jpg"]
},
{
  id: 3,
  name: "John-d",
  specialty: "Event Manager",
  experience: "5 years",
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/yfyxye30_01a3ea47-72f2-40a2-a3b5-3f56772063be.jpg",
  bio: "At the heart of every unforgettable event at Tagline Tattoo Studio is John-D, he's the mastermind behind the energy, the flow, and the vibe. Driven by creativity and precision, John-D doesn't just organize events, he crafts experiences that connect art, people, and culture in one unforgettable space.",
  portfolio: ["tattoo5.jpg", "tattoo6.jpg"]
}];


export const galleryTattoos = [
{
  id: 1,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/6a8u4qu7_WhatsApp%20Image%202026-03-28%20at%2021.01.59.jpeg",
  style: "Floral Shoulder"
},
{
  id: 2,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/5lznqa9j_IMG_1169.jpeg",
  style: "Portrait Memorial"
},
{
  id: 3,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/1hq4y23q_73a21fb2-1a63-4633-a068-f458d99f8257.jpg",
  style: "Growth & Nature"
},
{
  id: 4,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/aidav9wt_IMG-20250624-WA0023.jpg",
  style: "Tropical Scene"
},
{
  id: 5,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/kekdie67_IMG-20250624-WA0024.jpg",
  style: "Script Lettering"
},
{
  id: 6,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/0nfr23yq_IMG-20250624-WA0026.jpg",
  style: "Nautical Design"
},
{
  id: 7,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/a0c2ax1w_IMG-20250624-WA0027.jpg",
  style: "Memorial Tribute"
},
{
  id: 8,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/x77geaw5_IMG-20250624-WA0028.jpg",
  style: "Cartoon Art"
},
{
  id: 9,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/82vsfbpk_IMG-20250624-WA0029.jpg",
  style: "Lion Portrait"
},
{
  id: 10,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/mp0li51p_IMG-20251126-WA0003.jpg",
  style: "Abstract Art"
},
{
  id: 11,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/7yikgqhc_IMG_5014%20%281%29.JPG",
  style: "Spiritual Geometry"
},
{
  id: 12,
  image: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/cf2vvzg9_IMG_4657.jpg",
  style: "Phoenix & Florals"
}];


export const galleryEvents = [
{
  id: 1,
  video: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/eu3pgjjt_WhatsApp%20Video%202026-03-28%20at%2021.01.59.mp4",
  title: "Midrand Fresher",
  date: "March 2026"
},
{
  id: 2,
  video: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/unkuh5id_VID_20251029_095055.mp4",
  title: "Hhumo Pop-up",
  date: "October 2025"
},
{
  id: 3,
  video: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/9wom81xr_VID_20250901_114112.mp4",
  title: "Reggies pop up",
  date: "September 2025"
},
{
  id: 4,
  video: "https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/3dxpypxb_VID-20260202-WA0017.mp4",
  title: "YouFm interview",
  date: "February 2026"
}];


export const services = [
{
  id: 1,
  name: "Tattooing",
  description: "Custom tattoo designs from our expert artists. From small minimalist pieces to full sleeve masterpieces.",
  price: "Starting at R250 ",
  icon: "Brush"
},
{
  id: 2,
  name: "Piercings",
  description: "Professional body piercing services with high-quality jewelry and strict hygiene standards.",
  price: "Starting at R150",
  icon: "Circle"
},
{
  id: 3,
  name: "Merchandise",
  description: "Exclusive studio merchandise including apparel, art prints, and accessories.",
  price: "Varies",
  icon: "ShoppingBag"
},
{
  id: 4,
  name: "Pop-Up Events",
  description: "We bring our studio to you! Book us for conventions, festivals, and private events.",
  price: "Contact for quote",
  icon: "Calendar"
}];


export const reviews = [
{
  id: 1,
  name: "Kealeboga Angel Ntheledi",
  rating: 5,
  date: "2024-04-19",
  comment: "This place is amazing, got the most beautiful tattoo ever! Amazing and affordable services too🥹 Keep it up guys!",
  service: "Tattooing"
},
{
  id: 2,
  name: "Bloom Haze",
  rating: 5,
  date: "2024-08-20",
  comment: "Wonderful experience + great work, easily the best tattoo studio in town. The best place to get your first tattoo, the artists were soo patient and comforting.🔥🔥",
  service: "Tattooing"
},
{
  id: 3,
  name: "Ofentse Selogilwe",
  rating: 5,
  date: "2024-08-06",
  comment: "Tagline tattoo studio is the best in rustenburg ❤️ Quality tattoos & talented artists.. 🥰",
  service: "Tattooing"
},
{
  id: 4,
  name: "Mothupi Omphile",
  rating: 5,
  date: "2025-03-04",
  comment: "I advice to go get there tattoo at Tagline Tattoo Studio, i got 2 today and they look beautiful. I got mine go and get yours 😉😉😉😉",
  service: "Tattooing"
},
{
  id: 5,
  name: "Inolofatseng Motloba",
  rating: 5,
  date: "2024-10-03",
  comment: "Clean. Professional. And a great vibe that makes you feel instantly Comfortable.",
  service: "Tattooing"
},
{
  id: 6,
  name: "makgaka mmakgosana",
  rating: 5,
  date: "2024-09-27",
  comment: "Tagline Tattoos transforms meaningful phrases into stunning works of art on skin! Their attention to detail and creativity truly bring each design to life.",
  service: "Tattoo design"
},
{
  id: 7,
  name: "Hlolelo Rampete",
  rating: 5,
  date: "2024-04-19",
  comment: "I haven't necessarily gotten service but the personnel were so welcoming. I am definitely getting a tattoo very soon.",
  service: "Consultation"
},
{
  id: 8,
  name: "Kagiso Rapoo",
  rating: 5,
  date: "2024-08-13",
  comment: "Excellent service and amazing tattoo work. Highly recommend!",
  service: "Tattooing"
}];


export const timeSlots = [
"10:00 AM",
"11:00 AM",
"12:00 PM",
"1:00 PM",
"2:00 PM",
"3:00 PM",
"4:00 PM",
"5:00 PM",
"6:00 PM",
"7:00 PM",
"8:00 PM"];


// Mock booking storage (browser localStorage)
export const mockBookingSubmit = (bookingData) => {
  const bookings = JSON.parse(localStorage.getItem('tattoo_bookings') || '[]');
  const newBooking = {
    ...bookingData,
    id: Date.now(),
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  bookings.push(newBooking);
  localStorage.setItem('tattoo_bookings', JSON.stringify(bookings));
  return newBooking;
};

// Mock review submission
export const mockReviewSubmit = (reviewData) => {
  const existingReviews = JSON.parse(localStorage.getItem('tattoo_reviews') || '[]');
  const newReview = {
    ...reviewData,
    id: Date.now(),
    date: new Date().toISOString(),
    approved: false
  };
  existingReviews.push(newReview);
  localStorage.setItem('tattoo_reviews', JSON.stringify(existingReviews));
  return newReview;
};